export default "__VITE_ASSET__TwbYSc8M__"